/* eslint-disable react/prop-types */
import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Icon, Text, NakedButton } from 'roo-ui/components';

const CurrentImageTextWrapper = styled(Text)`
  position: absolute;
  right: ${themeGet('space.3')};
  bottom: ${themeGet('space.3')};
  color: ${themeGet('colors.white')};
  padding: ${themeGet('space.1')} ${themeGet('space.2')};
  pointer-events: none;
  font-size: ${themeGet('fontSizes.xs')};
  background-color: rgba(34, 34, 34, 0.6);
  border-radius: ${themeGet('radii.default')};
`;

export const CurrentImageText = ({ images, selectedIndex }) => (
  <CurrentImageTextWrapper>
    {selectedIndex + 1} / {images.length}
  </CurrentImageTextWrapper>
);

const GalleryButton = styled(NakedButton)`
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.rounded')};
  z-index: ${themeGet('zIndices.imageGallery')};
  position: absolute;
  opacity: 0.8;
  top: 50%;
  margin-top: -${themeGet('space.4')};
  left: ${(props) => (props.left ? props.left : 'initial')};
  right: ${(props) => (props.right ? props.right : 'initial')};

  &:focus {
    box-shadow: 0 0 0 2pt ${themeGet('colors.blue')};
    outline: 0;
  }

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

export const LeftNav = ({ onClick }) => (
  <GalleryButton left="8px" onClick={onClick}>
    <Icon name="chevronLeft" color="greys.charcoal" title="previous image" size={30} />
  </GalleryButton>
);

export const RightNav = ({ onClick }) => (
  <GalleryButton right="8px" onClick={onClick}>
    <Icon name="chevronRight" color="greys.charcoal" title="next image" size={30} />
  </GalleryButton>
);
